import { config, handleResponse } from '../../_helpers';

export const chargeService = {
    getAllCharges,
    getChargeById,
    updateCharge,
    createCharge,
    searchCharge,
    deleteCharge,
    activation,
    getFullCharges,
    createChargeMulti,
    GetChargeForCreateCharge,
    getGlAccountIdFromBase,
    getStrippingStuffingSelection,
    getMasterCharge,
};

function getMasterCharge() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Charges`, requestOptions).then(handleResponse);
}

function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/Charges/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}

function getAllCharges(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search && filter) {
        return fetch(`${config.apiUrl}/Charges/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Charges/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function getChargeById(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Charges/get/${code}`, requestOptions).then(handleResponse);
}

function updateCharge(charge, profile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            code: charge.code,
            name: charge.name,
            printName: charge.printName,
            openVanApply: charge.openVanApply,
            category: charge.category,
            chargeClass: charge.chargeClass,
            unitOfMeasure: charge.unitOfMeasure,
            backLoadApply: charge.backLoadApply,
            cargoType: charge.cargotypeCode,
            isVatable: charge.isVatable,
            showInSq: charge.showInSq,
            isDangerousCargo: charge.isDangerousCargo,
            isShipperOwn: charge.isShipperOwn,
            isInsurancePremium: charge.isInsurancePremium,
            isLiftOnOff: charge.isLiftOnOff,
            isStrippingStuffingCharge: charge.isStrippingStuffingCharge,
            userModified: profile.userId,
            // glAccountId: charge.glAccountId,
            // glAccountDescription: charge.glAccountDescription,
            updateItemCodes: charge.itmeCodeDetails,
            isVanOut: charge.isVanOut,
            appliedBranches: charge.isVanOut === true ? charge.appliedBranches : [],
            isSpecialCharge: charge.isSpecialCharge,
            effectiveDateBasis: charge.effectiveDateBasis,
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Charges/update/${charge.code}`, requestOptions).then(handleResponse);
}
function createChargeMulti(charge, serviceMatrix, userProfile) {
    let payload = [{
        tblCharges: {
            code: charge.code,
            name: charge.name,
            printName: charge.printName,
            openVanApply: charge.openVanApply,
            category: charge.category,
            chargeClass: charge.chargeClass,
            unitOfMeasure: charge.unitOfMeasure,
            backLoadApply: charge.backLoadApply,
            cargoType: charge.cargoType,
            isVatable: charge.isVatable,
            showInSq: charge.showInSq,
            isDangerousCargo: charge.isDangerousCargo,
            isShipperOwn: charge.isShipperOwn,
            isInsurancePremium: charge.isInsurancePremium,
            isLiftOnOff: charge.isLiftOnOff,
            isStrippingStuffingCharge: charge.isStrippingStuffingCharge,
            userCreated: userProfile.userId,
            isVanOut: charge.isVanOut,
            appliedBranches: charge.isVanOut === true ? charge.appliedBranches : [],
            // glAccountId: charge.glAccountId,
            // glAccountDescription: charge.glAccountDescription,
            isSpecialCharge: charge.isSpecialCharge,
            effectiveDateBasis: charge.effectiveDateBasis,
        },
        createItemCodes: charge.ItemCode,
        tblChargeServicesMatrix: serviceMatrix
    }]
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Charges/multipleInsert`, requestOptions).then(handleResponse);
}

function createCharge(charge, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(
            {
                code: charge.code,
                name: charge.name,
                printName: charge.printName,
                openVanApply: charge.openVanApply,
                category: charge.category,
                chargeClass: charge.chargeClass,
                unitOfMeasure: charge.unitOfMeasure,
                backLoadApply: charge.backLoadApply,
                userCreated: userProfile.userId,
                glAccountId: charge.glAccountId,
                glAccountDescription: charge.glAccountDescription,
            }
        ),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Charges`, requestOptions).then(handleResponse);
}


function deleteCharge(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/Charges/delete`, requestOptions).then(handleResponse);
}

function searchCharge(skip, take, search, filter) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Charges/load?skip=${skip}&take=${take}&search=${search}&filter=${filter}`, requestOptions).then(handleResponse);
}

function getFullCharges(category) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Charges/getIsActive?category=${category}`, requestOptions).then(handleResponse);
}

function GetChargeForCreateCharge() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Charges/getAllCharges`, requestOptions).then(handleResponse);
}

function getGlAccountIdFromBase(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Charges/getGlAccountIdFromBase`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Charges/getItemCodeFromBase`, requestOptions).then(handleResponse);
}

function getStrippingStuffingSelection(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Charges/getStrippingStuffingSelection`, requestOptions).then(handleResponse);
}
